var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "gfu-project-description-section gfu-project-description-section--emphasized",
    },
    [
      _c(
        "div",
        {
          ref: "anchor",
          staticClass:
            "gfu-layout-wrapper gfu-layout-wrapper--extranarrow gfu-4of5--l gfu-3of5--xl",
          attrs: {
            "data-qa": `project-description-section-title:${_vm.header}`,
          },
        },
        [
          _c("base-slider", {
            ref: "slider",
            attrs: {
              mode: "slide",
              items: _vm.sliderItems,
              "extra-large-screen-visible-items-count": 3,
              "slide-gap-classes": "_px-1",
              "scroll-container-wrapper-classes": "_pos-r _-mx-1",
              "navigation-wrapper-classes": "_as-fs _shrink-0",
            },
            on: {
              "scroll-left": function ($event) {
                return _vm.onScroll("left")
              },
              "scroll-right": function ($event) {
                return _vm.onScroll("right")
              },
              "get-items": _vm.onGetItems,
            },
            scopedSlots: _vm._u([
              {
                key: "prefix",
                fn: function () {
                  return [
                    _c(
                      "base-heading",
                      {
                        staticClass: "_mb-1",
                        attrs: { divider: "left", tag: "h2" },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.Resources.ProjectHome.ProjectTimelineHeader
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "localize",
                      {
                        attrs: {
                          resource:
                            _vm.Resources.ProjectHome
                              .ProjectTimelineProgressInfoMessage,
                        },
                      },
                      [
                        _c("span", { attrs: { "format-key": "0" } }, [
                          _c(
                            "a",
                            {
                              staticClass: "gfu-link gfu-link--accent",
                              attrs: { href: _vm.helpUrl },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.Resources.ProjectHome
                                      .ProjectTimelineHelpLabel
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "gfu-link gfu-link--accent",
                            attrs: {
                              "format-key": "1",
                              href: _vm.crowdfundingGuideUrl,
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.Resources.ProjectHome
                                    .ProjectTimelineCrowdfundingGuideLabel
                                )
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "slide",
                fn: function ({ item }) {
                  return [
                    _c(
                      "project-section-timeline-card",
                      _vm._b({}, "project-section-timeline-card", item, false)
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }